import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  focusedLabel: {
    color: "rgba(173, 178, 190, 1) !important",
  },
  radioLabel: {
    '&:hover':{
      background: 'none',
      backgroundColor: 'none',
    }
  },
}));

const RadioGroupInput = ({
  label,
  options,
  defaultValue,
  name,
  handleChange,
  handleBlur,
  value,
  column, // row or col
}) => {
  const classes = useStyles();
  return (
    <FormControl component="fieldset" className="my-3">
      {label && (
        <FormLabel
          component="legend"
          classes={{ focused: classes.focusedLabel }}
        >
          {label}
        </FormLabel>
      )}
      <RadioGroup
        defaultValue={defaultValue}
        value={value}
        aria-label={label}
        name={name}
        className={`d-flex ${column ? "flex-column" : "flex-row"}`}
        onChange={handleChange}
        onBlur={handleBlur}
      >
        {options.map((option, index) =>
          //option as icon
          option.icon ? (
            <Radio
              key={index}
              style={{ width: "fit-content", padding: "0px" }}
              classes={{ root: classes.radioLabel }}
              value={option.value}
              checkedIcon={option.checkedICon}
              icon={option.icon}
            />
          ) : (
            //as radio & label
            <FormControlLabel
              key={index}
              classes={{ root: classes.radioLabel }}
              value={option.value}
              control={<Radio />}
              label={option.label}
            />
          )
        )}
      </RadioGroup>
    </FormControl>
  );
};
export default RadioGroupInput;
RadioGroupInput.prototypes = {
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  column: PropTypes.string,
};
